import { wordByCount } from '@shared/lib/utils/word-by-count/word-by-count';
import { Dot } from '../ui/side-list-organizations.styles';

export const getOrganizationDescription = (users: number, products: number) => {
    const countUsers = wordByCount({
        count: users,
        words: ['сотрудник', 'сотрудника', 'сотрудников'],
    });

    const countProducts = wordByCount({
        count: products,
        words: ['продукт', 'продукта', 'продуктов'],
    });

    return (
        <>
            {countUsers}
            <Dot />
            {countProducts}
        </>
    );
};
